import React, { useContext } from 'react';

import { IntersectionContext } from 'components/intersection-observer';
import { cardContainer, cardItemVariants } from 'theme/motion.variants';
import { MotionBox } from 'components/common/MotionBox';

import {
  ServicesContainer,
  ServicesWrapper,
  ServicesHeading,
  ServicesCard,
  ServicesIcon,
  ServicesTitle,
  ServicesParagraph
} from './services.styles';
import { Underline } from 'components/common/Underline';
import { servicesData } from './services.data';

const Services = () => {
  const { inView } = useContext(IntersectionContext);

  return (
    <ServicesContainer id="services">
      <ServicesHeading>Our Services</ServicesHeading>
      <Underline light />
      <ServicesWrapper
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        exit="exit"
        variants={cardContainer}
      >
        {servicesData.map(({ id, src, title, paragraph }) => (
          <MotionBox variants={cardItemVariants} key={id}>
            <ServicesCard whileHover={{ scale: 1.05, transition: 0.2 }}>
              <ServicesIcon src={src} />
              <ServicesTitle>{title}</ServicesTitle>
              <ServicesParagraph>{paragraph}</ServicesParagraph>
            </ServicesCard>
          </MotionBox>
        ))}
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
